import { useState } from "react";
import { X } from "lucide-react";

// Freelancer Portal Upgrade Phase 3 (2026-02) — the ONE deliberate, founder-approved
// relaxation of "a freelancer only ever sees themselves". `members` (passed in from
// GET /v1/community/members) already contains ONLY {id, name, primary_role, photo, city} —
// nothing else is ever rendered here because nothing else was ever fetched.
export function MemberPicker({ members, selected, onChange, onClose }) {
  const [query, setQuery] = useState("");
  const filtered = members.filter((m) => (m.name || "").toLowerCase().includes(query.toLowerCase()));
  const isSelected = (id) => selected.some((s) => s.id === id);
  const toggle = (m) => onChange(isSelected(m.id) ? selected.filter((s) => s.id !== m.id) : [...selected, m]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose} data-testid="community-member-picker-overlay">
      <div className="w-full max-w-sm rounded-xl bg-paper border border-hairline shadow-xl max-h-[70vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-hairline p-3">
          <span className="text-xs font-semibold uppercase tracking-wider text-ink-soft">Tag Contributors</span>
          <button onClick={onClose} data-testid="community-member-picker-close"><X className="h-4 w-4 text-faint" /></button>
        </div>
        <div className="p-3 border-b border-hairline">
          <input
            value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search by name…"
            data-testid="community-member-picker-search"
            className="w-full rounded-md border border-hairline bg-surface2/40 px-3 py-1.5 text-xs text-ink placeholder:text-faint focus:outline-none focus:border-brand/50"
          />
        </div>
        <div className="overflow-y-auto flex-1 p-2 space-y-1" data-testid="community-member-picker-list">
          {filtered.length === 0 && <div className="text-xs text-faint text-center py-6">No members found</div>}
          {filtered.map((m) => (
            <button key={m.id} onClick={() => toggle(m)} data-testid={`community-member-option-${m.id}`}
              className={`w-full flex items-center gap-2.5 rounded-md px-2.5 py-2 text-left transition-colors ${isSelected(m.id) ? "bg-brand/15" : "hover:bg-surface2/50"}`}>
              {m.photo ? (
                <img src={m.photo} alt="" className="h-7 w-7 rounded-full object-cover shrink-0" loading="lazy" decoding="async" />
              ) : (
                <div className="h-7 w-7 rounded-full bg-hairline flex items-center justify-center text-[10px] font-semibold shrink-0">{(m.name || "?")[0]}</div>
              )}
              <div className="min-w-0 flex-1">
                <div className="text-xs text-ink truncate">{m.name}</div>
                <div className="text-[10px] text-faint truncate">{m.primary_role}{m.city ? ` · ${m.city}` : ""}</div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
